import { Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParam } from "react-use";
import useAuth from "../../../hooks/useAuth";

const TexkeysDebugToggle = ({ ...props }) => {
  const debug = useSearchParam("debug");
  const { currentUser } = useAuth();

  if (!debug || currentUser == null) return null;
  else return <TextkeyToggle />;
};

const TextkeyToggle = () => {
  const [showTextkeys, setShowTextkeys] = useState(false);

  const { i18n } = useTranslation();

  useEffect(() => {
    if (showTextkeys) {
      i18n.options.fallbackLng = [];
      i18n.changeLanguage("asd");
    } else {
      i18n.options.fallbackLng = "en";
      i18n.changeLanguage("en");
    }
  }, [showTextkeys]);

  const handleChange = (e) => {
    setShowTextkeys(e.target.checked);
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "1vw",
        right: "1vw",
        display: "flex",
        width: "auto",
        alignItems: "center",
        background: "red",
        pointerEvents: "auto",
        padding: "0.2vw",
        zIndex: 19999,
        color: "white",
      }}
    >
      <input type="checkbox" onChange={handleChange} defaultChecked={false} />
      <div>Show Textkeys</div>
    </div>
  );
};

export default TexkeysDebugToggle;
